/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { RoutePath } from '../../../routes/constants/routesConstants';

export const getWizardImportPersonalDataUrl = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PageWizardImportPersonalData]
        ? RoutePath.wizardImportPersonalData
        : ExternalRoutePath.mobilePersonalData;

export const isWizardImportPersonalDataExternalUrl = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageWizardImportPersonalData];

